/* eslint-disable no-duplicate-case */
import { Banner } from "@shopify/polaris";
import React from "react";
import { useSelector } from "react-redux";
import config from "../../config/config";
const BannerWoo = () => {
  const dataSettings = useSelector((state) => state.dataSettings);

  return (
    <div>
      {config.platform == "WOO_COMMERCE" && dataSettings.plan_expired_at ? (
        <Banner status="warning">
          You've canceled or paused your <b>{dataSettings.plan}</b>{" "}
          subscription. You'll get full functionality of it until{" "}
          <b>{dataSettings.plan_expired_at}</b>, after which your store will be
          reverted back to the <b>Free</b> plan.
        </Banner>
      ) : null}
    </div>
  );
};

export default BannerWoo;
